import { BillingApiFactory } from '@mynt/backoffice-api-spec/billables'
import { TemplateRelationsApiFactory, TemplatesApiFactory } from '@mynt/backoffice-api-spec/templates'
import Axios from 'api/axios'
import config from 'config'
import type { Amount } from './api'
import { mapSubscriptionFeeResponseToSubscriptionFee, mapTemplate, mapTemplateRelation } from './mappers'

const templatesApi = TemplatesApiFactory(undefined, config.boBaseUrl, Axios)
const relationsApi = TemplateRelationsApiFactory(undefined, config.boBaseUrl, Axios)
const billingApi = BillingApiFactory(undefined, config.boBaseUrl, Axios)

export const getTemplateOnCustomer = (customerId: string) =>
  templatesApi.getTemplateForCustomer(customerId, { disableCustomErrorHandler: true }).then(({ data }) => mapTemplate(data))

export const setTemplateOnCustomer = (customerId: string, templateId: string, keepCustomerOverrides: boolean) =>
  templatesApi.replaceCustomerTemplate(customerId, { templateId, keepCustomerOverrides })

export const getAllRelations = (templateId?: string) =>
  relationsApi.getAllRelations(templateId).then(({ data }) => data.map(mapTemplateRelation))

export const getAllTemplates = () => templatesApi.getAllTemplates().then(({ data }) => data.map(mapTemplate))

export const getSubscriptionFee = (customerId: string) =>
  billingApi.getCustomerSubscriptionFee(customerId).then(({ data }) => mapSubscriptionFeeResponseToSubscriptionFee(data))

export const setSubscriptionFee = (customerId: string, subscriptionFee: Amount) =>
  billingApi
    .setCustomerSubscriptionFee(customerId, { subscriptionFee })
    .then(({ data }) => mapSubscriptionFeeResponseToSubscriptionFee(data))

export const deleteSubscriptionFeeOverride = (customerId: string) =>
  billingApi.removeCustomerSubscriptionFee(customerId).then(({ data }) => mapSubscriptionFeeResponseToSubscriptionFee(data))
